import { Component, Input } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IApiDocumentType } from 'src/app/shared/modules/graphql/types/types';

@Component({
  selector: 'app-report-prefill',
  templateUrl: './report-prefill.component.html',
  styleUrls: ['./report-prefill.component.scss']
})
export class ReportPrefillComponent extends DialogContentBase {
  @Input() reportType: IApiDocumentType;
  private checked = "\u2611";

  public checkboxes = [
    {
      text: "Additional inspections/testing necessary",
      value: `${this.checked} Additional inspections/testing necessary`,
      checked: false
    },
    {
      text: "Additional consultants/experts requested",
      value: `${this.checked} Additional consultants/experts requested`,
      checked: false
    },
    {
      text: "Fire scene taped and placarded",
      value: `${this.checked} Fire scene taped and placarded`,
      checked: false
    },
    {
      text: "Physical evidence retained",
      value: `${this.checked} Physical evidence retained`,
      checked: false
    },
    {
      text: "Photographs to follow",
      value: `${this.checked} Photographs to follow`,
      checked: false
    },
    {
      text: "Complete report to follow",
      value: `${this.checked} Complete report to follow`,
      checked: false
    },
  ]
  public isChecked = false;
  public none = false;

  constructor(public dialog: DialogRef) {
    super(dialog)
  }

  close(result = true) {
    this.dialog.close({
      cancel: result,
      data: null
    });
  }

  createReport() {
    const checkboxes = this.checkboxes.filter(c => c.checked)?.map(c => c?.value);
    if (!checkboxes?.length && !this.none) {
      return;
    }
    this.dialog.close({
      data: checkboxes,
      cancel: false
    });
  }

  onSelect() {
    this.none = false;
    this.isChecked = this.checkboxes?.some(c => c.checked);
  }

  onChangeNone() {
    if (this.none === true) {
      this.checkboxes?.forEach(box => {
        box.checked = false;
      })
      this.isChecked = true;
    } else {
      this.isChecked = this.checkboxes?.some(c => c.checked);
    }
  }
}
